var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9C17 6.85537 16.1461 4.90947 14.7669 3.47135C14.7094 3.37236 14.6273 3.28985 14.5286 3.23177C13.0906 1.85292 11.1443 1 9 1C4.58962 0.999999 1 4.58962 1 9C1 11.14 1.85 13.0823 3.22396 14.5195C3.28395 14.6264 3.37225 14.7148 3.47917 14.7747C4.91651 16.1494 6.85933 17 9 17C13.4104 17 17 13.4104 17 9ZM15.6667 9C15.6667 12.6898 12.6898 15.6667 9 15.6667C7.39575 15.6667 5.92729 15.1034 4.77864 14.1641L14.1641 4.77865C15.1034 5.92729 15.6667 7.39575 15.6667 9ZM13.2214 3.83594L3.83594 13.2214C2.89655 12.0727 2.33333 10.6042 2.33333 9C2.33333 5.3102 5.31021 2.33333 9 2.33333C10.6042 2.33333 12.0727 2.89655 13.2214 3.83594Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBan);
export default __webpack_public_path__ + "static/media/icon-ban.870fbe890d8fadfce6cc8236616c13d1.svg";
export { ForwardRef as ReactComponent };